/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update an existing entitlement (only provided fields are updated)
 * @export
 * @interface UpdateEntitlementRequest
 */
export interface UpdateEntitlementRequest {
    /**
     * Effective to (ISO-8601). Null = no expiry.
     * @type {Date}
     * @memberof UpdateEntitlementRequest
     */
    effectiveTo?: Date;
    /**
     * Quantity (seats or units)
     * @type {number}
     * @memberof UpdateEntitlementRequest
     */
    quantity?: number;
    /**
     * Quantity limit (null = unlimited)
     * @type {number}
     * @memberof UpdateEntitlementRequest
     */
    quantityLimit?: number;
    /**
     * When true, clears effectiveTo (no expiry). Ignored when effectiveTo is set.
     * @type {boolean}
     * @memberof UpdateEntitlementRequest
     */
    clearEffectiveTo?: boolean;
}

/**
 * Check if a given object implements the UpdateEntitlementRequest interface.
 */
export function instanceOfUpdateEntitlementRequest(value: object): value is UpdateEntitlementRequest {
    return true;
}

export function UpdateEntitlementRequestFromJSON(json: any): UpdateEntitlementRequest {
    return UpdateEntitlementRequestFromJSONTyped(json, false);
}

export function UpdateEntitlementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEntitlementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'effectiveTo': json['effectiveTo'] == null ? undefined : (new Date(json['effectiveTo'])),
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
        'clearEffectiveTo': json['clearEffectiveTo'] == null ? undefined : json['clearEffectiveTo'],
    };
}

export function UpdateEntitlementRequestToJSON(json: any): UpdateEntitlementRequest {
    return UpdateEntitlementRequestToJSONTyped(json, false);
}

export function UpdateEntitlementRequestToJSONTyped(value?: UpdateEntitlementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effectiveTo': value['effectiveTo'] == null ? undefined : ((value['effectiveTo']).toISOString()),
        'quantity': value['quantity'],
        'quantityLimit': value['quantityLimit'],
        'clearEffectiveTo': value['clearEffectiveTo'],
    };
}

